module.exports = __webpack_public_path__ + "img/course.22261d18.png";